module.exports = __webpack_public_path__ + "img/icon-restaurant-ordertoday.02ce4903.png";